// extracted by mini-css-extract-plugin
export default {"root":"DiscountBlock_root-O2y","text":"DiscountBlock_text-OgI"};